import {useEffect, useState} from 'react'
import {TowelsFilters} from './components/TowelsFilters'
import {TowelsTable} from './components/TowelsTable'
import {useTowels} from './hooks/useTowels'
import {Towel} from './types/towel.types'
import {Pagination} from '../../../_metronic/layout/components/Pagination'
import {getZones} from '../management/zones/services/zones.service'

export const TowelsPage = () => {
  const {towelsByStatus, loading} = useTowels()

  const [towels, setTowels] = useState<Towel[]>([])
  const [filtered, setFiltered] = useState<Towel[]>([])
  const [zones, setZones] = useState<any[]>([])

  const [page, setPage] = useState(1)
  const perPage = 10

  const start = (page - 1) * perPage
  const paginated = filtered.slice(start, start + perPage)
  const totalPages = Math.ceil(filtered.length / perPage)

  const [filters, setFilters] = useState({
    status: '',
    tipo: '',
    zona: '',
    codigo: '',
  })

  useEffect(() => {
    loadZones()
  }, [])

  const loadZones = async () => {
    try {
      const data = await getZones()
      setZones(data || [])
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    const allTowels = Object.values(towelsByStatus).flat()
    setTowels(allTowels)
    setFiltered(allTowels)
  }, [towelsByStatus])

  useEffect(() => {
    let result = [...towels]

    if (filters.status) {
      result = result.filter((t) => t.estado === filters.status)
    }

    if (filters.tipo) {
      result = result.filter((t) => t.tipo === filters.tipo)
    }

    if (filters.zona) {
      result = result.filter((t) => t.zone_id === filters.zona)
    }

    if (filters.codigo) {
      result = result.filter((t) => t.codigo.toLowerCase().includes(filters.codigo.toLowerCase()))
    }

    setFiltered(result)
    setPage(1)
  }, [filters, towels])

  return (
    <>
      <div className='d-flex align-items-center justify-content-end'>
        <TowelsFilters filters={filters} setFilters={setFilters} zones={zones} towels={towels} />
      </div>
      {loading ? (
        <tr>
          <td colSpan={7} className='text-center py-15'>
            <div className='d-flex flex-column align-items-center justify-content-center'>
              <div className='spinner-border text-primary mb-3' role='status' />

              <span className='text-muted fw-semibold'>Cargando toallas...</span>
            </div>
          </td>
        </tr>
      ) : (
        <>
          <TowelsTable
            key={`${page}-${filters.status}-${filters.tipo}-${filters.zona}`}
            data={paginated}
          />

          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </>
      )}
    </>
  )
}
